var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.651 60.67-10.65-12.604V25.972h1.332a2 2 0 1 0 0-4H38a2 2 0 0 0-2 2v24.864c0 .495.184.973.516 1.34l8.148 9.834h-25.33l8.148-9.834c.332-.367.516-.845.516-1.34V23.972a2 2 0 0 0-2-2h-3.332a2 2 0 1 0 0 4h1.332v22.094L13.349 60.67a2.001 2.001 0 0 0 1.484 3.34h34.334a2 2 0 0 0 1.484-3.34ZM30 19.98A3.99 3.99 0 1 0 30 12a3.99 3.99 0 0 0 0 7.98Zm13.03-5.937c3.898 0 7.058-3.146 7.058-7.026S46.928-.009 43.03-.009c-3.897 0-7.058 3.146-7.058 7.026s3.16 7.026 7.058 7.026ZM42.999 3.98a3.018 3.018 0 0 1 3.02 3.008A3.018 3.018 0 0 1 43 9.995a3.018 3.018 0 0 1-3.021-3.008 3.018 3.018 0 0 1 3.02-3.008Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat4);
export default __webpack_public_path__ + "static/media/cat-4.28628617e636020dd81c91cb5e96f582.svg";
export { ForwardRef as ReactComponent };